// tslint:disable: variable-name
export class Settings {
  public TraceActive = true;
  public UseCryptographyOnCustomerStaffData = true;
  public UpdatingGatewaysTables = false;
  public LicenceVersion = 0;
  public LicenceExpiringUsername = "";
  public TimeSlot1Always = 60;
  public LicenceAccessControl = true;
  public LicenceAllowedAddresses = 2147483647;
  public LicenceAllowedRooms = 2147483647;
  public LicenceAllowedCardProgrammerGateways = 2147483647;
  public LicenceAllowedFinalGateways = 2147483647;
  public EnabledFinalGateways = "";
  public LicenceBlackBox = true;
  public LicenceCalendar = true;
  public LicenceDeviceAndAddress = true;
  public LicenceLogicAndAlarm = true;
  public LicenceMultiInstanceGUID = true;
  public LicencePreconditioning = true;
  public LicenceReport = true;
  public LicenceSceneAndSchedule = true;
  public LicenceSupervisioning = true;
  public LicenceAccounting = true;
  public LicenceEnergyPeriod = true;
  public LicenceDataProcess = true;
  public LicenceScheduledReport = true;
  public LicenceType = 0;
  public LicenceExpiringDate = new Date().getDate();
  public LicenceEmergencyLamps = true;
  public LicencePMSInterface = true;
  public LicenceFidelio = true;
  public LicenceHospitalCall = true;
  public LicenceSaflock = true;
  public LicenceSalto = true;
  public LicenceSimonVoss = true;
  public LicenceSIP = true;
  public LicenceForcedMachineID = "";
  public HistoryAccessPresenceAreCrypted = false;
  public LicenceGSM = true;
  public ViewCustomerStaffDividedByUserGroup = false;
  public LicenceIntesis = true;
  public LicenceBlueWave = true;
  public LicencePlateRecognition = true;
  public AstronomicalClock_Enable = true;
  public MQTTServerEnabled = false;
  public MQTTServerPort = 1883;
  public CoreManager_DeleteOldLog_Interval = 3600;
  public EMail_Server = "smtp.bigsrl.it";
  public EMail_ServerPort = 25;
  public EMail_SMTPUser = "bigstudio@bigsrl.it";
  public EMail_SMTPPassword = "BIG$tudi0!";
  public EMail_SenderMail = "bigstudio@bigsrl.it";
  public EMail_SenderName = "BIGStudio notifiche";
  public Mail_EnableSSL = false;
  public CoreManager_DailyHistory_SaveOnDisk_RemoveFileDaysOlder = 120;
  public CoreManager_DailyHistory = false;
  public CoreManager_AccessControlFailedOperation_MaxAttempts = 3;
  public CoreManager_AccessControlFailedOperation_WaitAfterWrite = 1;
  public CoreManager_AccessControlFailedOperation_WaitCheck = 120;
  public CoreManager_AccessControlFailedOperation_WaitResponse = 5;
  public CoreManager_OtherFailedOperation_MaxAttempts = 3;
  public CoreManager_OtherFailedOperation_WaitAfterWrite = 5;
  public CoreManager_OtherFailedOperation_WaitCheck = 120;
  public CoreManager_OtherFailedOperation_WaitResponse = 5;
  public EMail_EnableTSL = false;
  public LogicManager_Report_SaveOnDisk = false;
  public LogicManager_Report_SaveOnDisk_Folder = "";
  public LogicManager_Report_SaveOnDisk_RemoveFileDaysOlder = 60;
  public LogicManager_Report_FTP = false;
  public LogicManager_Report_FTP_Host = "";
  public LogicManager_Report_FTP_Port = 21;
  public LogicManager_Report_FTP_Username = "";
  public LogicManager_Report_FTP_Password = "";
  public BackupManager_BackupScheduling = false;
  public RefreshScenarioSynchInterval = 5;
  public CheckActiveService_Enable = false;
  public CoreManager_DeleteLogFile_DaysOlder = 15;
  public CoreManager_DeleteDeviceCommands_DaysOlder = 45;
  public CoreManager_DeleteLogEvents_DaysOlder = 30;
  public CoreManager_DeleteLoginHistory_DaysOlder = 30;
  public CoreManager_DeleteAccessHistory_DaysOlder = 180;
  public CoreManager_DeletePresenceHistory_DaysOlder = 180;
  public CoreManager_DeleteLogAllTelegrams_DaysOlder = 5;
  public CoreManager_DeleteBackup_DaysOlder = 180;
  public CoreManager_DeleteBlackBox_DaysOlder = 45;
  public CoreManager_DeleteDeleteDataProcessed_DaysOlder = 1825;
  public CoreManager_LogTelegrams_EnableArchive = false;
  public CoreManager_DeleteDeviceStates_DaysOlder = 500;
  public BackupManager_BackupPathname = "";
  public SaveBackgroundSizeCustomInterface = true;
  public LicenceLoRa = true;
  public LANIP = "";
  public WANIP = "";
  public CheckconnectionsMaxWait = 60;
  public CheckActiveService_TypeScheduling = 2;
  public CheckActiveService_DayOfWeek = 2;
  public CheckActiveService_DayOfMonth = 1;
  public CheckActiveService_Hour = 0;
  public CheckActiveService_Minute = 0;
  public BackupManager_TypeBackupScheduling = 2;
  public BackupManager_TimeOfBackupScheduling = "03:00";
  public BackupManager_DayOfBackupScheduling = 1;
  public CoreManager_LogTelegrams_ArchiveDaysOlder = 10;
  public CoreManager_LogTelegrams_ArchiveDBTable = "";
  public ExpertModePassword = "boIwVoZFviAq+3g9uXM79Q==";
  public SnapToGrid = true;
  public GridStep = 8;
  public CustomInterface_PeriodicalReadInterval = 5;
  public DefaultDecimalDigits = 1;
  public UseThousandSeparatorForValueKeyword = true;
  public CI_ShowGrid = true;
  public CI_DefaultResolution = "1920x1080";
  public CountryCode = "ITA";
  public LogicManager_NotifyAlwaysAlarmBypassingUserSettings = true;
  public LogicManager_NotifyWithWindow = true;
  public LogicManager_NotifyWithWindowAllowClose = false;
  public LogicManager_NotifyWithSound = true;
  public LogicManager_NotifyWithSoundSelectedID = -1;
  public LogicManager_NotifyWithSoundRepeat = false;
  public LogicManager_NotifyWithSoundRepeatInterval = 1;
  public LogicManager_NotifyWithBalloon = false;
  public LogicManager_NotifyWithPageJump = false;
  public LogicManager_NotifyWithPageJumpPageID = -1;
  public LogicManager_NotifyMaskingTime = 60;
  public Notification_ShowGridIntoNotificationPopupWindow = true;
  public Notification_ShowViewCommandsButtonIntoNotificationPopupWindow = true;
  public Notification_ShowResetCommandsButtonIntoNotificationPopupWindow = true;
  public MaxNumberActiveAlarmInGrid = 50;
  public AutoCheckIn = false;
  public DefaultDepartureTime = "10:00";
  public DefaultArrivalTime = "14:30";
  public CustomerKeyRoomAccessesLimit = 1;
  public StaffKeyRoomAccessesLimit = 1;
  public UseCheckOutTimeForCustomerCards: string = "";
  public UseCheckInTimeForCustomerCards: string = "";
  public AccessManager_ExpiredCustomerCards_Invalidate = false;
  public AccessManager_ExpiredCustomerCards_DelayForInvalidate = 0;
  public AccessManager_ExpiredCustomerCards_DeleteFromDB = false;
  public AccessManager_ExpiredCustomerCards_DelayForDeleteFromDB = 365;
  public AccessManager_ArchivedCustomers_Delete = false;
  public AccessManager_ArchivedCustomers_DelayForDelete = 365;
  public DefaultCustomerCardsExpirationDays = 1;
  public DefaultStaffCardsExpirationDays = 365;
  public AddCommonAccessesToNewCard = true;
  public AllowRewriteCard = true;
  public PlannerDaysToLoad = 10;
  public AccessControlMode = 0;
  public ShowToolbarAccessControlCustomers = true;
  public ShowToolbarAccessControlReservations = true;
  public AccessManager_TrackRealTimePresence = false;
  public AccessManager_SendNotificaionExpiringCardEnable = false;
  public AccessManager_SendNotificaionExpiringCardDaysBefore = 5;
  public AccessManager_SendNotificaionExpiringCardNotification = 0;
  public AccessManager_SendNotificaionExpiringCardCheckTime = "09:00";
  public AccessControl_NotificationEnabled = false;
  public AccessControl_NotificationID = 0;
  public AccessControlViewMode = 0;
  public AccessControlTemplateFCCustomer = 0;
  public AccessControlTemplateFCStaff = 0;
  public AccessControlShowCommonAreaFC = false;
  public AccessManager_WaitSendAckToMAC = 3;
  public AccessManager_Polling_MinTransitForRead = 10;
  public AccessManager_Polling_MaxIgnoredLoop = 5;
  public AccessManager_Polling_TransitToRead = 254;
  public AccessManager_Polling_MaxTransitToReadForRequest = 6;
  public AccessManager_Polling_WaitBetweenLoops = 60;
  public AccessManager_Polling_WaitBetweenDevices = 5;
  public AccessManager_Polling_WaitBetweenTransitRequests = 5;
  public AccessManager_Polling_WaitForStatusResponse = 2;
  public AccessManager_Polling_WaitForTransitResponse = 2;
  public AccessManager_WaitForSendTransit = 750;
  public AccessManager_WriteOnCardsSpecialAccessRights = false;
  public PMS_SelectedPMS = 0;
  public PMS_ForceCardWriteONBusOnCreation = false;
  public ShowSystemCalendars = true;
  public CalendarMonthsToView = 6;
  public GridDevicesRealTimeUpdate = true;
  public CoreManager_DailyHistory_Login = false;
  public CoreManager_DailyHistory_Value = false;
  public CoreManager_DailyHistory_Access = false;
  public CoreManager_DailyHistory_BlackBox = false;
  public CoreManager_DailyHistory_Command = false;
  public CoreManager_DailyHistory_Alarm = false;
  public CoreManager_DailyHistory_Presence = false;
  public CoreManager_DailyHistory_ExportFormat = 0;
  public CoreManager_DailyHistory_EMail = false;
  public CoreManager_DailyHistory_Email_Receivers = "";
  public CoreManager_DailyHistory_SaveOnDisk = false;
  public CoreManager_DailyHistory_SaveOnDisk_Folder = "";
  public CoreManager_DailyHistory_FTP = false;
  public CoreManager_DailyHistory_FTP_Host = "";
  public CoreManager_DailyHistory_FTP_Port = "";
  public CoreManager_DailyHistory_FTP_Username = "";
  public CoreManager_DailyHistory_FTP_Password = "";
  public BlumotixCodeLenght = 4;
  public CardAccessControlUpperKeyA = 43690;
  public CardAccessControlMidKeyA = 43690;
  public CardAccessControlLowerKeyA = 43690;
  public CardAccessControlUpperKeyB = 48059;
  public CardAccessControlMidKeyB = 48059;
  public CardAccessControlLowerKeyB = 48059;
  public VimarExecActionOnlyOnCardType = "1|2|3|4|5|6";
  public AstronomicalClock_Latitude = "4.439.071";
  public AstronomicalClock_Longitude = "754.828";
  public AstronomicalClock_SunriseOffset = 0;
  public AstronomicalClock_SunsetOffset = -30;
  public ClearedDeviceKindImages = true;
  public UseInternalSkin = true;
  public InternalSkinName = "OFFICE2010_SILVER";
  public ExternalSkinFile = "";
  public ShowStatusBar = true;
  public ShowActiveAlarmList = false;
  public ShowTabs = false;
  public ShowMultilineTabs = false;
  public ShowUnknonwState = false;
  public LastPanel = "CUSTOMINTERFACES";
  public DefaultLanguage = "it";
  public First_CleanAddressKind = true;
  public First_ReseIncorrectZIndex = true;
  public GSM_SiemensMC35i_DeviceManufacturer = 0;
  public GSM_SiemensMC35i_DeviceModel = 1;
  public GSM_SiemensMC35i_CommandWrite = 1;
  public GSM_SiemensMC35i_CommandRead = 1;
  public GSM_SiemensMC35i_BaudeRate = 115200;
  public GSM_SiemensMC35i_TransactTimeout = 6000;
  public GSM_SiemensMC35i_HandShake = 0;
  public GSM_SiemensMC35i_Parity = 0;
  public GSM_SiemensMC35i_DataBits = 8;
  public GSM_SiemensMC35i_StopBits = 1;
  public vGSM_SiemensMC35i_TxFlowRTS = false;
  public GSM_SiemensMC35i_TxFlowDTR = false;
  public GSM_SiemensMC35i_TxTerminator = "";
  public GSM_SiemensMC35i_RxTerminator = 10;
  public GSM_SiemensMC35i_TerminatorRegEx = "";
  public GSM_SiemensMC35i_SendOnReceive = true;
  public GSM_SiemensMC35i_MaxTimeout = 450;
  public GSM_SiemensMC35i_TimeoutMultiplier = 17;
  public GSM_DigicomPocketGSM_DeviceManufacturer = 2;
  public GSM_DigicomPocketGSM_DeviceModel = 2;
  public GSM_DigicomPocketGSM_CommandWrite = 1;
  public GSM_DigicomPocketGSM_CommandRead = 1;
  public GSM_DigicomPocketGSM_BaudeRate = 9600;
  public GSM_DigicomPocketGSM_TransactTimeout = 6000;
  public GSM_DigicomPocketGSM_HandShake = 0;
  public GSM_DigicomPocketGSM_Parity = 0;
  public GSM_DigicomPocketGSM_DataBits = 8;
  public GSM_DigicomPocketGSM_StopBits = 1;
  public GSM_DigicomPocketGSM_TxFlowRTS = true;
  public GSM_DigicomPocketGSM_TxFlowDTR = true;
  public GSM_DigicomPocketGSM_TxTerminator = "";
  public GSM_DigicomPocketGSM_RxTerminator = 10;
  public GSM_DigicomPocketGSM_TerminatorRegEx = "";
  public GSM_DigicomPocketGSM_SendOnReceive = true;
  public GSM_DigicomPocketGSM_MaxTimeout = 450;
  public GSM_DigicomPocketGSM_TimeoutMultiplier = 17;
  public CleanDaily = false;
  public FrigoDaily = false;
  public PreConditioningAllTotalMinutes = 120;
  public BIGStudio2PlantName = "";
  public LastPage = 100;
  public LastSupervisionOpened = 1282;
  public ShowTitleBar = false;
  public ShowTelegramsInStatusBar = true;
  public ShowRoomDescriptionOnPlanner = false;
  public ConnectionStatusNotify = false;
  public OpenLastPageOpened = true;
  public TemperatureUOM = 1;
  public ShowMenuBar = true;
  public ModBusConfiguraion_ViewInWord = true;
  public LicenceADS = true;
  public AccessManager_DeleteWhiteListInDownload = true;
  public EMail_WithoutAuthentication = false;
  public PMS_OnCheckInChangeOnlyCustomerName = false;
  public PMS_RemoveCardNotInCheckInFromPMS = false;
  public PMS_RemoveCardNotInCheckInFromPMSHour = 12;
  public PMS_RemoveCardNotInCheckInFromPMSMinute = 30;
  public HiddenColumns_gridEnvironmentsRoomStatusSettings = "";
  public LicenceDAHUA = true;
  public MQTTServerPortWS = 8022;
  public DahuaCodeLenght = 6;
  public DefaultReservationDays = 1;
  public CoreManager_LogAllTelegrams = false;
  public LogicManager_Report_EMail = false;
  public LogicManager_Report_EMail_Receivers = "";
  public MQTTServerPortWSWAN: "8022";
  public NotLimitCustomerKeyAccesses: boolean = true;
  public NotLimitStaffKeyAccesses: boolean = true;
  public PriceProfile1_Name: string = "Profilo di pagamento 1";
  public PriceProfile2_Name: string = "Profilo di pagamento 2";
  public PriceProfile3_Name: string = "Profilo di pagamento 3";
  public PriceProfile4_Name: string = "Profilo di pagamento 4";
  public ShowAccessControl: boolean = true;
  public ShowConfiguration: boolean = true;
  public ShowDevices: boolean = true;
  public ShowEmergencyLamps: boolean = true;
  public ShowLogics: boolean = true;
  public ShowPlanner: boolean = true;
  public ShowReport: boolean = true;
  public ShowReport_Accesses: boolean = true;
  public ShowReport_Alarms: boolean = true;
  public ShowReport_BlackBox: boolean = true;
  public ShowReport_CommandsValues: boolean = true;
  public ShowReport_Comunications: boolean = false;
  public ShowReport_CustomerStaff: boolean = true;
  public ShowReport_DataProcess: boolean = true;
  public ShowReport_EmergencyLamps: boolean = true;
  public ShowReport_EnableExportButton: boolean = false;
  public ShowReport_Keys: boolean = true;
  public ShowReport_Logics: boolean = true;
  public ShowReport_Login: boolean = true;
  public ShowReport_Payments: boolean = true;
  public ShowReport_Presences: boolean = false;
  public ShowReport_ReportCustom: boolean = true;
  public ShowReport_SceneExecution: boolean = false;
  public ShowReport_ShowAddresses: boolean = false;
  public ShowReport_ShowCustomXLSX: boolean = false;
  public ShowSceneAndSchedule: boolean = true;
  public ShowScene_Editing: boolean = true;
  public ShowScene_Play: boolean = true;
  public ShowSchedule_Editing: boolean = true;
  public ShowSetup: boolean = true;
  public ShowSetup_AccessControl: boolean = true;
  public ShowSetup_AccessControlABB: boolean = true;
  public ShowSetup_AccessControlEnvironmentView: boolean = true;
  public ShowSetup_AlarmNotification: boolean = true;
  public ShowSetup_AstronomicalClock: boolean = true;
  public ShowSetup_BackupRestore: boolean = true;
  public ShowSetup_BackupSchedule: boolean = true;
  public ShowSetup_Country: boolean = true;
  public ShowSetup_CustomReportSavingSending: boolean = true;
  public ShowSetup_DailyHistoryExport: boolean = true;
  public ShowSetup_Database: boolean = true;
  public ShowSetup_General: boolean = true;
  public ShowSetup_Language: boolean = true;
  public ShowSetup_Log: boolean = true;
  public ShowSetup_Misc: boolean = true;
  public ShowSetup_PMSInterface: boolean = true;
  public ShowSetup_SMTPServer: boolean = true;
  public ShowSetup_Server: boolean = true;
  public ShowSetup_Skin: boolean = true;
  public ShowSetup_Supervision: boolean = true;
  public ShowSetup_UserPassword: boolean = true;
  public ShowSupervision: boolean = true;
  public ShowSupervision_Editing: boolean = true;
  public ShowScanAndGo: boolean = true;
  public ShowReadTag: boolean = false;
  public ShowWeeklyPlannings: boolean = true;
  public AllowDeleteUsersAndCards: boolean = false;
  public AllowStaffCardCreation: boolean = false;
  public EditWeeklyPlannings: boolean = true;
  public ShowVideoCamerasSection: boolean = true;
  public AllowWANConnection: boolean = true;
  public DefaultHomepageUser: string = "";
  public PushOneSignalAppID: string = "";
  public PushEnabled: boolean = false;
  public ShowFastCheckIn: boolean = false;
  public ShowMyAccesses: boolean = true;
  public ShowMyQRCode: boolean = true;
  public AllowCustomerStaffCreation: boolean = true;
  public AllowCustomerStaffEdit: boolean = true;
  public AllowCustomerStaffDelete: boolean = true;
  public AllowCardCreation: boolean = true;
  public AllowCardEdit: boolean = true;
  public AllowCardGenericOperation: boolean = true;
  public ShowLastNotification: boolean = false;
  public ShowDrawTemplateHTML: boolean = false;
  public ShowLoadControl: boolean = false;
  public ShowGateways: boolean = false;
  public AllowCardEnvironmentEdit: boolean = true;
  public AllowCardDelete: boolean = true;
  public Plants: boolean = true;
  public ShowCloudServiceConfiguration: boolean = false;
  public AllowCreationCondominium: boolean = false;
  public AccessInvitationManagement: boolean = false;
  public AccessUserDirectory: boolean = false;
  public AllowModificationCondominiumData: boolean = false;
  public ShowBuildingParts: boolean = false;
  public ShowDeviceListPartsBuilding: boolean = false;
  public AllowChangesBuildingPart: boolean = false;
  public AllowUserModificationBuildingPart: boolean = false;
  public ShowBuildingPartsUsers: boolean = false;
  public AccessInviteMaintainersSystem: boolean = false;
  public AllowViewUserAssocatedCondominium: boolean = false;
  public AllowViewInvitedUsers: boolean = false;
  public AccessConsumptionResearch: boolean = false;
  public AccessBillManagement: boolean = false;
  public AccessQuoteManagement: boolean = false;
  public AccessExpenseNotes: boolean = false;
  public AllowChangesExpenseNotes: boolean = false;
  public AllowManageDevicePartsBuilding: boolean = false;
  public AllowConfigurationSmartcomponent: boolean = false;
  public AllowIntegration: boolean = false;
  public AllowWeeklyPlanningEditOption: boolean = false;
  public AllowWeeklyPlanningEditDailySector: boolean = false;

  constructor(settingsObject?: any) {
    if (settingsObject) {
      Object.assign(this, settingsObject);
      this.convertPropertyFromStringToBoolean();
    }
  }

  /**
   * Read a setting as a boolean, denying anything that is not explicitly enabled.
   *
   * Settings reach the app as the strings "TRUE"/"FALSE" and {@link convertPropertyFromStringToBoolean}
   * normalises them, but that never runs on a state rehydrated from storage: the persisted blob is
   * a plain object, not a Settings instance, so a raw "FALSE" survives it. Reading such a value
   * directly grants the very permission it denies, a non-empty string being truthy — hence this
   * accessor for every permission gate.
   *
   * @param value raw setting value: already a boolean, still a string, or absent
   * @returns `true` only for `true` or "TRUE" (any casing); anything else denies
   */
  public static isEnabled(value: boolean | string | null | undefined): boolean {
    if (typeof value === "string") {
      return value.toUpperCase() === "TRUE";
    }

    return value === true;
  }

  private convertPropertyFromStringToBoolean() {
    const booleanProperties = [
      "NotLimitStaffKeyAccesses",
      "NotLimitCustomerKeyAccesses",
      "ShowAccessControl",
      "ShowConfiguration",
      "ShowDevices",
      "ShowEmergencyLamps",
      "ShowLogics",
      "ShowPlanner",
      "ShowReport",
      "ShowReport_Accesses",
      "ShowReport_Alarms",
      "ShowReport_BlackBox",
      "ShowReport_CommandsValues",
      "ShowReport_Comunications",
      "ShowReport_CustomerStaff",
      "ShowReport_DataProcess",
      "ShowReport_EmergencyLamps",
      "ShowReport_EnableExportButton",
      "ShowReport_Keys",
      "ShowReport_Logics",
      "ShowReport_Login",
      "ShowReport_Payments",
      "ShowReport_Presences",
      "ShowReport_ReportCustom",
      "ShowReport_SceneExecution",
      "ShowReport_ShowAddresses",
      "ShowReport_ShowCustomXLSX",
      "ShowSceneAndSchedule",
      "ShowScene_Editing",
      "ShowScene_Play",
      "ShowSchedule_Editing",
      "ShowSetup",
      "ShowSetup_AccessControl",
      "ShowSetup_AccessControlABB",
      "ShowSetup_AccessControlEnvironmentView",
      "ShowSetup_AlarmNotification",
      "ShowSetup_AstronomicalClock",
      "ShowSetup_BackupRestore",
      "ShowSetup_BackupSchedule",
      "ShowSetup_Country",
      "ShowSetup_CustomReportSavingSending",
      "ShowSetup_DailyHistoryExport",
      "ShowSetup_Database",
      "ShowSetup_General",
      "ShowSetup_Language",
      "ShowSetup_Log",
      "ShowSetup_Misc",
      "ShowSetup_PMSInterface",
      "ShowSetup_SMTPServer",
      "ShowSetup_Server",
      "ShowSetup_Skin",
      "ShowSetup_Supervision",
      "ShowSetup_UserPassword",
      "ShowSupervision",
      "ShowSupervision_Editing",
      "ShowScanAndGo",
      "ShowReadTag",
      "ShowWeeklyPlannings",
      "AllowDeleteUsersAndCards",
      "AllowStaffCardCreation",
      "EditWeeklyPlannings",
      "ShowVideoCamerasSection",
      "AllowWANConnection",
      "PushEnabled",
      "ShowFastCheckIn",
      "ShowMyAccesses",
      "ShowMyQRCode",
      "AllowCustomerStaffCreation",
      "AllowCustomerStaffEdit",
      "AllowCustomerStaffDelete",
      "AllowCardCreation",
      "AllowCardEdit",
      "AllowCardGenericOperation",
      "ShowLastNotification",
      "ShowDrawTemplateHTML",
      "ShowLoadControl",
      "ShowGateways",
      "AllowCardEnvironmentEdit",
      "AllowCardDelete",
      "ShowCloudServiceConfiguration",
      "AllowCreationCondominium",
      "AccessInvitationManagement",
      "AccessUserDirectory",
      "AllowModificationCondominiumData",
      "ShowBuildingParts",
      "ShowDeviceListPartsBuilding",
      "AllowChangesBuildingPart",
      "AllowUserModificationBuildingPart",
      "ShowBuildingPartsUsers",
      "AccessInviteMaintainersSystem",
      "AllowViewUserAssocatedCondominium",
      "AllowViewInvitedUsers",
      "AccessConsumptionResearch",
      "AccessBillManagement",
      "AccessQuoteManagement",
      "AccessExpenseNotes",
      "AllowChangesExpenseNotes",
      "AllowManageDevicePartsBuilding",
      "AllowConfigurationSmartcomponent",
      "AllowIntegration",
      "AllowWeeklyPlanningEditOption",
      "AllowWeeklyPlanningEditDailySector"
    ];

    booleanProperties.forEach((prop) => {
      if (this[prop] === "TRUE") {
        this[prop] = true;
      } else if (this[prop] === "FALSE") {
        this[prop] = false;
      }
    });
  }
}
